import $ from "jquery";
import {$window, $body} from '../../../Constants';
import HtmlElement from '../../../Elements/HtmlElement';
import ProductController from '../Controller/ProductController';

/**
 * Attributes Table
 */
const AttributesTable = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		ATTRIBUTES_TABLE_WRAP: '.article-table-wrap',
		TABLE: '.article-table'
	};

	/**
	 * Attributes Table
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class AttributesTable extends HtmlElement {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			super.onReady();

			this._$table = this.$element.find(Selector.TABLE);

			this._initialize();
		}

		_initialize() {
			const isPrint = window.matchMedia('print').matches;

			this.markAdvisorResults();

			this.$element.data('instance', this);
			this.$element.append('<div class="cloned-wrapper"></div>');
			const $clonedWrapper = this.$element.find('.cloned-wrapper');
			const $tableClone = this._$table.clone().appendTo($clonedWrapper);

			const tableWidth = this._$table.outerWidth();
			let firstColumnWidth = this._$table.find('th:first-of-type').outerWidth();
			const $priceColumn = this._$table.find('.price');
			const sliceNumber = $priceColumn.length ? -3 : -2;

			const $firstColumn = this._$table.find('th:first-of-type');
			const $lastColumns = this._$table.find('th').slice(sliceNumber);

			let $otherColumns = this._$table.find('th').not($firstColumn);

			const lastHeadColumns = this._$table.find('th').slice(sliceNumber);
			const lastColumnsWidths = [...lastHeadColumns.map((i, el) => $(el).outerWidth())];
			const lastColumnsTotalWidth = lastColumnsWidths.reduce((acc, curr) => acc + curr);

			this.scrollContainerWidth = tableWidth - firstColumnWidth;

			if ($window.width() >= 1024) {
				$otherColumns = $otherColumns.not($lastColumns);
				this.scrollContainerWidth = this.scrollContainerWidth - lastColumnsTotalWidth;

				if ($priceColumn.find('span').length) {
					this.scrollContainerWidth += 138;
				}
			}

			$otherColumns.each((thIndex, th) => {
				const $th = $(th);

				this._$table.find('tbody tr').each((rowIndex, row) => {
					const index = thIndex + 1 === $otherColumns.length ? $otherColumns.length : thIndex + 1;
					const $row = $(row);
					const $td = $row.find('td').eq(index);

					if (thIndex === 0 && !isPrint) {
						$td.empty();
						$td.addClass('scroll-spacing');
						$td.css('width', this.scrollContainerWidth);
					} else {
						$td.addClass('remove');
					}
				});

				if (thIndex === 0 && !isPrint) {
					$th.empty();
					$th.addClass('scroll-spacing');
					$th.css('width', this.scrollContainerWidth);
				} else {
					$th.addClass('remove');
				}
			});

			/* this._$table.find('td.price').each((i, el) => {
				console.log($(el).html());
				if (!$(el).find('span').length) {
					$tableClone.find('.price').eq(i).text($(el).text());
				}
			}); */

			if (!isPrint) {
				this._$table.find('th.remove, td.remove').remove();
			}

			const thHeights = [];
			const cloneThHeights = [];
			const tdHeights = [];
			const cloneTdHeights = [];

			this._$table.find('th').each((i, el) => {
				thHeights.push($(el).outerHeight());
			});

			this._$table.find('td').each((i, el) => {
				tdHeights.push($(el).outerHeight());
			});

			$tableClone.find('th').each((i, el) => {
				cloneThHeights.push($(el).outerHeight());
			});

			$tableClone.find('td').each((i, el) => {
				cloneTdHeights.push($(el).outerHeight());
			});

			const maxThHeight = Math.max(Math.max(...thHeights), Math.max(...cloneThHeights));
			const maxTdHeight = Math.max(Math.max(...tdHeights), Math.max(...cloneTdHeights));

			$tableClone.find('th').each((i, el) => {
				$(el).css('height', maxThHeight);
			});

			this._$table.find('th').each((i, el) => {
				$(el).css('height', maxThHeight);
			});

			$tableClone.find('td').each((i, el) => {
				$(el).css('height', maxTdHeight);
			});

			this._$table.find('td').each((i, el) => {
				$(el).css('height', maxTdHeight);
			});

			this._$table.find('tbody tr').each((rowIndex, row) => {
				$(row).find('td').each((tdIndex, td) => {
					$tableClone.find('tr').eq(rowIndex).find('td').eq(tdIndex).css('height', $(td).outerHeight());
				});
			});

			if (!isPrint) {
				$tableClone.find('th:first-of-type, td:first-of-type').remove();
			}

			if ($window.width() >= 1024 && !isPrint) {
				$tableClone.find('tr').each(function() {
					$(this).find('th').slice(sliceNumber).remove();
					$(this).find('td').slice(sliceNumber).remove();
				});
			}

			this.scrollContainerWidth = this._$table.find('th.scroll-spacing').outerWidth();

			firstColumnWidth = this._$table.find('th:first-of-type').outerWidth();

			$clonedWrapper.css({
				left: firstColumnWidth,
				width: this._$table.find('th.scroll-spacing').outerWidth()
			});

			ProductController._loadArticlePrices();

			window.addEventListener('beforeprint', () => {
				if (!$('.article-table-print').length) {
					const $printClone = $('.article-table-wrap').clone().addClass('article-table-print');

					// Add th from cloned-wrapper to original table
					$printClone.find('.cloned-wrapper th').insertAfter($printClone.find('> .article-table th:first-of-type'));
					$printClone.find('.scroll-spacing').remove();

					$printClone.find('.cloned-wrapper tbody tr').each((trIndex, tr) => {
						const $originalRow = $printClone.find('> .article-table tbody tr').eq(trIndex);
						$(tr).find('td').insertAfter($originalRow.find('td:first-of-type'));
					});

					$printClone.find('> .article-table tbody > tr').each((i, bodyTr) => {
						$(bodyTr).find('td').each((tdIndex, td) => {
							const labelContent = $printClone.find('> .article-table th').eq(tdIndex).html();
							const tdContent = $(td).html();
							$(td).html(`<span class="table-print-label">${labelContent}: </span>${tdContent}`);
						});
					});

					$printClone.find('thead th').each((i, el) => {
						const text = $(el).text();
						$(el).html(text.replace(' [', '<br>['));
					});

					$printClone.insertAfter('.article-table-wrap');
					$printClone.find('.cloned-wrapper').remove();

					ProductController._loadArticlePrices();
				}
			});
		}

		adjustScrollSpacings() {
			this.scrollContainerWidth = this.scrollContainerWidth - 138;
			this.$element.find('.cloned-wrapper, .scroll-spacing').css('width', this.scrollContainerWidth);
		}

		/**
		 * Read advisor results from local storage and add css class to affected rows
		 */
		markAdvisorResults() {
			const advisorResults = JSON.parse(localStorage.getItem('advisorResults'));
			if(advisorResults && advisorResults.includes) {
				this._$table.find('.note-article').each((index, element) => {
					if (advisorResults.includes($(element).data('uid'))) {
						$(element).parents('tr').addClass('advisor-result');
						this.$element.next('.text-right').find('.article-table-legend').show();
					}
				});
			}
		}
	}

	return AttributesTable._getElement($body.find(Selector.ATTRIBUTES_TABLE_WRAP), AttributesTable);
})();

export default AttributesTable;
